export default {
  // Navigation
  home: '首页',
  solutions: '解决方案',
  sectors: '行业',
  ecosystem: '生态系统',
  about: '关于我们',
  recruitment: '招聘',
  contact: '联系我们',

  // Hero Section
  heroHeadline: '用正确的技术转型您的企业',
  heroSubheadline: 'Alpha Solutions 为非洲企业集成、部署和支持 ERP 系统及业务软件——从审计到上线，再到持续支持。',
  requestConsultation: '申请咨询',
  discoverSolutions: '查看我们的解决方案',

  // What We Do Section
  whatWeDoTitle: '我们的专业领域',
  whatWeDoSubtitle: '完整的技术解决方案，数字化、自动化并掌控您业务的每个方面。',
  businessSoftware: '企业软件',
  businessSoftwareDesc: 'ERP、CRM、会计、人力资源——集中管理并驱动整个运营的管理系统。',
  industrySoftware: '行业软件',
  industrySoftwareDesc: '酒店、餐饮、零售、教育、医疗——专为您的行业打造的解决方案。',
  automationDigitalization: '自动化与数字化',
  automationDigitalizationDesc: '自动化流程，连接系统，用数据管理您的业务。',
  smartInfrastructure: '智能基础设施与安全',
  smartInfrastructureDesc: '视频监控、门禁控制、生物识别和网络——保护并连接您的企业。',

  // Why Choose Us Section
  whyChooseTitle: '我们的与众不同',
  whyChooseSubtitle: '不仅仅是供应商——真正的合作伙伴，理解您的挑战并引导您做出正确的技术决策。',
  solutionExpertise: '解决方案专业知识',
  solutionExpertiseDesc: '我们的团队掌握广泛的技术，能够为每种情况识别最合适的解决方案。',
  technologySelection: '技术选型',
  technologySelectionDesc: '我们分析市场，为您推荐最适合您行业的最佳工具。',
  reliableImplementation: '可靠实施',
  reliableImplementationDesc: '严格部署、全面测试和引导上线，确保顺利启动。',
  trainingSupport: '培训与支持',
  trainingSupportDesc: '全面的团队培训和全天候支持，让您充分发挥投资价值。',

  // Technology Ecosystem Section
  techEcosystemTitle: '世界级技术，本地专业知识',
  techEcosystemSubtitle: '我们与可信赖的软件发行商和技术供应商合作，提供适应非洲市场的成熟解决方案。',
  techEcosystemDesc: 'Alpha Solutions 依托全球技术合作伙伴网络，为您提供可靠、现代且可扩展的系统——在本地选择、集成和支持。',
  techEcosystemFeature1: '获取全球市场上最佳技术',
  techEcosystemFeature2: '经全球数千家企业验证的系统',
  techEcosystemFeature3: '适应非洲市场现实和约束的解决方案',
  techEcosystemFeature4: '具有国际专业知识的本地法语支持',

  // Industries Served Section
  industriesServedTitle: '我们了解您的行业',
  industriesServedSubtitle: '专为每个行业的运营现实打造的解决方案，从酒店业到金融业。',
  sectorNotListed: '您的行业不在列表中？',
  discussProject: '讨论您的项目',

  // Sector names
  hotellerie: '酒店业',
  restauration: '餐饮业',
  beaute: '美容与健康',
  evenementiel: '活动策划',
  immobilier: '房地产',
  commerce: '零售与商业',
  production: '生产制造',
  education: '教育',
  sante: '医疗健康',
  transport: '运输与物流',
  finance: '金融',
  administration: '行政管理',

  // Call To Action Section
  ctaTitle: '让我们谈谈您的项目',
  ctaSubtitle: '我们的专家随时可以分析您的需求并推荐最佳解决方案——无需承诺。',
  ctaExpertTitle: '与专家交流',
  ctaExpertDesc: '从我们的技术专家那里快速获得问题解答。',
  ctaNeedsTitle: '分享您的需求',
  ctaNeedsDesc: '描述您的运营挑战，我们将提出合适的解决方案。',
  ctaDemoTitle: '申请演示',
  ctaDemoDesc: '通过针对您行业的个性化演示，亲眼看到我们的解决方案。',
  startConversation: '开始对话',
  callUs: '致电我们',
  ctaAvailability: '周一至周六 8:00 - 18:00 可用',
  contactExpert: '联系专家',
  shareNeeds: '分享我的需求',

  // Solutions Menu
  erp: 'ERP系统',
  crm: 'CRM系统',
  accounting: '会计',
  hr: '人力资源',

  // Footer
  footerDescription: '您值得信赖的数字化转型合作伙伴。我们帮助非洲企业采用市场上最佳技术，数字化运营、自动化流程并掌控业务活动。',
  ourServices: '我们的服务',
  usefulLinks: '实用链接',
  followUs: '关注我们',
  allRightsReserved: '版权所有',
  erpSystems: 'ERP系统',
  crmSystems: 'CRM系统',
  accountingSoftware: '会计软件',
  hrSoftware: '人力资源软件',
  industrySpecific: '行业解决方案',
  technologyIntegration: '技术集成',
  trustedAdvisor: '可信赖的技术顾问',
  digitalPartner: '数字化转型合作伙伴',
  solutionIntegrator: '解决方案集成商',
  expertSupport: '专家支持',

  // Call to Actions
  talkToExpert: '与专家交流',
  requestDemo: '申请演示',
  getStarted: '开始使用',
  learnMore: '了解更多',
  whatsappButton: '通过WhatsApp联系我们',
  whatsapp: 'WhatsApp',

  // Contact Page
  contactPageTitle: '让我们讨论您的项目',
  contactPageSubtitle: '我们的团队在2小时内回复。选择最适合您的方式。',
  contactConsultationTitle: '申请咨询',
  contactConsultationDesc: '与我们的专家讨论，分析您的需求并确定最适合您企业的技术解决方案。',
  contactDemoTitle: '申请演示',
  contactDemoDesc: '通过针对您行业的个性化演示，发现我们的解决方案。',
  contactExpertTitle: '与专家交流',
  contactExpertDesc: '从我们的专家那里快速获得技术或商业问题的解答。',
  formFullName: '全名',
  formCompany: '公司',
  formSector: '行业领域',
  formPhone: '电话/WhatsApp',
  formEmail: '电子邮件',
  formMessage: '您的留言',
  formRequestType: '请求类型',
  formSelectSector: '选择您的行业',
  formSelectRequest: '选择请求类型',
  requestConsultationType: '战略咨询',
  requestDemoType: '解决方案演示',
  requestQuoteType: '报价请求',
  requestSupportType: '技术支持',
  requestPartnershipType: '合作伙伴关系',
  requestOtherType: '其他',
  submitConsultation: '申请咨询',
  submitDemo: '申请演示',
  submitContact: '发送消息',
  sending: '发送中...',
  formSuccessTitle: '消息发送成功！',
  formSuccessMessage: '我们已收到您的请求。我们的团队将在2个工作小时内与您联系。',
  formErrorTitle: '发送错误',
  formErrorMessage: '发生错误。请重试或直接通过电话联系我们。',
  contactInfoTitle: '联系信息',
  contactInfoSubtitle: '多种联系方式',
  whatsappLabel: 'WhatsApp',
  phoneLabel: '电话',
  locationLabel: '位置',
  emailLabel: '电子邮件',
  locationAddress: '喀麦隆杜阿拉 Akwa',
  quickResponseTitle: '快速响应保证',
  quickResponseMessage: '我们承诺在2个工作小时内回复',
  businessHoursTitle: '营业时间',
  businessHoursWeekdays: '周一至周五：8:00 - 18:00',
  businessHoursSaturday: '周六：9:00 - 14:00',
  businessHoursSunday: '周日：休息',
  whyContactTitle: '为什么联系我们？',
  whyContact1: '8年公认专业知识',
  whyContact2: '针对您行业的解决方案',
  whyContact3: '法语本地支持',
  whyContact4: '个性化支持',

  // Ecosystem Page
  ecosystemHeroTitle: 'Alpha Solutions：技术与非洲之间的桥梁',
  ecosystemHeroSubtitle: 'Alpha Solutions 与可信赖的技术供应商、软件发行商和全球合作伙伴合作，提供适应非洲企业的最佳解决方案。',
  ecosystemHeroCTA1: '发现我们的合作伙伴',
  ecosystemHeroCTA2: '成为合作伙伴',
  ecosystemPartnersTitle: '可信赖技术合作伙伴网络',
  ecosystemPartnersSubtitle: '我们与全球技术供应商和软件发行商网络合作，提供可靠且经过验证的解决方案。',
  ecosystemPartner1Title: '全球技术供应商',
  ecosystemPartner1Desc: '我们与世界领先的技术提供商合作，获取市场上最先进、最可靠的系统。',
  ecosystemPartner2Title: '软件发行商',
  ecosystemPartner2Desc: '与专注于ERP、CRM、会计、人力资源和行业管理解决方案的软件发行商建立合作关系。',
  ecosystemPartner3Title: '解决方案提供商',
  ecosystemPartner3Desc: '提供自动化、安全、基础设施和云服务补充解决方案的合作伙伴网络。',
  ecosystemRoleTitle: '我们在生态系统中的使命',
  ecosystemRoleSubtitle: 'Alpha Solutions 充当全球技术与非洲企业需求之间的桥梁。',
  ecosystemRole1Title: '解决方案集成商',
  ecosystemRole1Desc: '我们选择、调整和集成最佳技术，以满足每个企业的特定需求。',
  ecosystemRole1Feature1: '深入的业务需求分析',
  ecosystemRole1Feature2: '选择最合适的解决方案',
  ecosystemRole1Feature3: '技术集成和配置',
  ecosystemRole1Feature4: '部署前的测试和验证',
  ecosystemRole2Title: '部署合作伙伴',
  ecosystemRole2Desc: '我们确保技术解决方案的完整部署，提供支持、培训和持续协助。',
  ecosystemRole2Feature1: '项目规划和管理',
  ecosystemRole2Feature2: '现场安装和配置',
  ecosystemRole2Feature3: '全面的用户培训',
  ecosystemRole2Feature4: '技术支持和维护',
  ecosystemRole3Title: '技术顾问',
  ecosystemRole3Desc: '我们通过推荐最适合其背景的解决方案，引导企业做出技术选择。',
  ecosystemRole3Feature1: '技术审计和诊断',
  ecosystemRole3Feature2: '战略建议',
  ecosystemRole3Feature3: '技术监测和创新',
  ecosystemRole3Feature4: '数字化转型支持',
  ecosystemBenefitsTitle: '为什么与我们的生态系统合作',
  ecosystemBenefitsSubtitle: '我们协作方式和技术合作伙伴网络的优势。',
  ecosystemBenefit1Title: '经过验证的解决方案',
  ecosystemBenefit1Desc: '获取经全球数千家企业测试和验证的技术。',
  ecosystemBenefit2Title: '本地专业知识',
  ecosystemBenefit2Desc: '将全球解决方案适应非洲市场的现实和约束。',
  ecosystemBenefit3Title: '持续支持',
  ecosystemBenefit3Desc: '法语本地技术协助和长期支持。',
  ecosystemBenefit4Title: '保证演进',
  ecosystemBenefit4Desc: '定期更新并获取解决方案的新功能。',
  ecosystemValuesTitle: '我们的合作价值观',
  ecosystemValuesSubtitle: '指导我们与技术供应商和客户合作的原则。',
  ecosystemValue1Title: '透明合作',
  ecosystemValue1Desc: '与我们的技术合作伙伴和客户进行开放诚实的沟通，确保每个项目的成功。',
  ecosystemValue2Title: '技术卓越',
  ecosystemValue2Desc: '致力于在解决方案的选择、集成和部署中保持最高质量标准。',
  ecosystemValue3Title: '相互信任',
  ecosystemValue3Desc: '基于信任、履行承诺和创造共同价值的持久关系。',
  ecosystemValue4Title: '持续创新',
  ecosystemValue4Desc: '不断寻找新技术和解决方案，以满足企业不断变化的需求。',
  ecosystemCTATitle: '加入我们的合作伙伴网络',
  ecosystemCTASubtitle: '您是软件发行商或技术供应商，正在寻找非洲可靠的本地合作伙伴？让我们讨论如何合作。',
  ecosystemCTAButton1: '联系我们',
  ecosystemCTAButton2: 'WhatsApp',
}
